import { TypeaheadItem } from '@app/shared/ui/typeahead/interfaces';
import { Pagination, SupabaseQueryParams } from '@app/shared/utils/interfaces';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Product } from '../interfaces';
import { ProductsEntity } from './products.models';

export const ProductsActions = createActionGroup({
  source: 'Products',
  events: {
    'Load Products': props<{ queryParams: SupabaseQueryParams }>(),
    'Load Products Success': props<{ products: ProductsEntity[]; total: number }>(),

    'Load More Products': props<{ queryParams: SupabaseQueryParams }>(),
    'Load More Products Success': props<{ products: ProductsEntity[]; total: number }>(),

    'Load Product': props<{ id: Product['id'] }>(),
    'Load Product Success': props<{ product: ProductsEntity }>(),

    'Load Sizes': emptyProps(),
    'Load Sizes Success': props<{ sizes: TypeaheadItem<string>[] }>(),

    'Set Selected Product': props<{ id: Product['id'] | undefined }>(),
    'Set Supabase Query Params': props<{ queryParams: SupabaseQueryParams }>(),
    'Set Pagination': props<{ pagination: Pagination }>(),

    'Products Failure': props<{ error: string | null }>(),
  },
});
